import * as yup from 'yup'
import { DashboardZones } from '../../entities/api/users/users'

const permissionSchema = yup.object({
	module: yup
		.mixed<DashboardZones>()
		.oneOf(Object.values(DashboardZones), 'Módulo inválido')
		.required('El módulo es obligatorio'),
	add: yup.boolean().required(),
	view: yup.boolean().required(),
	edit: yup.boolean().required(),
	remove: yup.boolean().required(),
})

export const userUpdateSchema = yup.object({
	name: yup.string().min(5).max(30),
	lastname: yup.string().min(5).max(30),
	permissions: yup
		.array()
		.of(permissionSchema)
		.optional()
		.notRequired()
		.test('valid-or-undefined', 'Faltan módulos requeridos', (val) => {
			if (!val || val.length === 0) return true
			const includedModules = val.map((p) => p.module)
			return Object.values(DashboardZones).every((mod) =>
				includedModules.includes(mod)
			)
		}),
})

export const userCreateSchema = yup.object({
	name: yup
		.string()
		.min(5, 'Mínimo 5 caracteres')
		.max(30, 'Máximo 30 caracteres')
		.required('El nombre es obligatorio'),

	lastname: yup
		.string()
		.min(5, 'Mínimo 5 caracteres')
		.max(30, 'Máximo 30 caracteres')
		.required('El apellido es obligatorio'),

	email: yup
		.string()
		.email('Correo inválido')
		.min(5)
		.max(50)
		.required('El correo es obligatorio'),

	phone: yup
		.number()
		.typeError('Debe ser un número válido')
		.integer('Debe ser un número entero')
		.test(
			'len',
			'Debe tener exactamente 10 dígitos',
			(val) => val !== undefined && val.toString().length === 10
		)
		.required('El teléfono es obligatorio'),

	password: yup
		.string()
		.required('La contraseña es obligatoria')
		.min(8, 'Mínimo 8 caracteres')
		.max(30, 'Máximo 30 caracteres')
		.test(
			'is-strong-password',
			'La contraseña debe incluir mayúsculas, minúsculas, un número y un carácter especial.',
			(value) => {
				if (!value) return false
				const hasUpperCase = /[A-Z]/.test(value)
				const hasLowerCase = /[a-z]/.test(value)
				const hasNumber = /\d/.test(value)
				const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value)
				return hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar
			}
		),

	permissions: yup
		.array()
		.of(permissionSchema)
		.optional()
		.notRequired()
		.test('valid-or-undefined', 'Faltan módulos requeridos', (val) => {
			if (!val || val.length === 0) return true
			const includedModules = val.map((p) => p.module)
			return Object.values(DashboardZones).every((mod) =>
				includedModules.includes(mod)
			)
		}),
})
